import React from 'react';
import { View, Text, Pressable } from 'react-native';
import { Icon } from 'LocalGluons';
import { t } from 'Locale';
import { useNavigation, useRoute, useIsFocused } from '@react-navigation/native';
import { useAppSelector, useAppDispatch } from 'ReduxStore/hooks';
import { show } from 'ReduxStore/drawer';
import NavigationService from './navigationService';
import styles from './navigationHeaderIcons.jss';
import { Device } from 'DeviceUtils';
/*
 * Used for Android when you are using only back icon on left and no icon on right.
 *  Title then will not be centered and you have to put this placeholder on right
 */
export const iconPlaceholder = <View style={styles.placeholderIcon} />;

export const IconMenu = () => {
    const dispatch = useAppDispatch();
    return (
        <Icon
            style={styles.menuIcon}
            onPress={() => {
                dispatch(show());
            }}
            name="menu"
            key="menu"
            testID="main_menu"
        />
    );
};

export const iconSearch = (
    <Icon
        style={styles.searchIcon}
        onPress={() => {
            NavigationService.getAppNavigationInstance().navigate('Search');
        }}
        name="search"
        key="search"
        testID="search_button"
    />
);

export const IconBack = ({ onPress = () => {} }) => {
    const navigation = useNavigation();
    return (
        <Icon
            style={styles.backIcon}
            onPress={() => {
                //* This is a workaround for the back button in the details screen
                //* to go back to the previous screen in the stack when canGoBack is falsely true,
                //* DO NOT MERGE THIS FOR DEPERSO BRANCH, THIS IS A TEMPORARY FIX for 4.0.26
                //* This will be removed for the deperso release, there is no need for this since the bug is not there
                const arrayLength = navigation.getState().routes.length;
                const lastRouteInArray = navigation.getState().routes[arrayLength - 1]?.name;
                const preLastRouteInArray = navigation.getState().routes[arrayLength - 2]?.name;
                if (lastRouteInArray === 'Details' && preLastRouteInArray === 'videostore') {
                    navigation.navigate('videostore');
                } else if (lastRouteInArray === 'Details' && preLastRouteInArray === 'home') {
                    navigation.navigate('home');
                } else {
                    if (onPress && typeof onPress === 'function') {
                        onPress();
                    } else {
                        navigation.popToTop();
                    }
                }
            }}
            name="arrow_left"
            key="arrow_left"
            testID="back_button"
        />
    );
};

export const IconFilter = () => {
    const route = useRoute();
    const filterActive = route.params?.filterActive || false;

    return (
        <Icon
            tintColor={filterActive ? '#00A0DE' : '#FFFFFF'}
            style={styles.filterIcon}
            onPress={() => {
                NavigationService.getAppNavigationInstance().setParams({
                    displayPageFilter: true
                });
            }}
            name="filter"
            key="filter"
            testID="filter_button"
        />
    );
};

export const IconBackWithText = ({
    onPress,
    testID = 'back_button',
    accessibilityLabel,
    label = t('COMMON.BACK')
}) => (
    <Pressable
        onPress={() => {
            if (onPress) {
                onPress();
            } else {
                const navigation = NavigationService.getAppNavigationInstance();

                //* This is a workaround for the back button in the details screen
                //* to go back to the previous screen in the stack when canGoBack is falsely true,
                //* DO NOT MERGE THIS FOR DEPERSO BRANCH, THIS IS A TEMPORARY FIX for 4.0.26
                //* This will be removed for the deperso release, there is no need for this since the bug is not there
                const arrayLength = navigation.getState().routes.length;
                const lastRouteInArray = navigation.getState().routes[arrayLength - 1]?.name;
                const preLastRouteInArray = navigation.getState().routes[arrayLength - 2]?.name;

                if (lastRouteInArray === 'Details' && preLastRouteInArray === 'videostore') {
                    navigation.navigate('videostore');
                } else if (lastRouteInArray === 'Details' && preLastRouteInArray === 'home') {
                    navigation.navigate('home');
                } else {
                    if (navigation.canGoBack()) {
                        navigation.goBack();
                    } else {
                        navigation.navigate('home');
                    }
                }
            }
        }}
        testID={testID}
        accessibilityLabel={accessibilityLabel}
        style={styles.backIconWithTextView}
    >
        <Icon style={styles.backIcon} name="arrow_left" key="arrow_left" />
        <Text style={styles.backIconWithTextText}>{label}</Text>
    </Pressable>
);
